// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inlinePaginationOuterWrapper___prU7F{margin-right:16px}.paginationRow___A9CRT{display:inline-flex;align-items:center}\n", "",{"version":3,"sources":["webpack://./src/components/Table/Pagination/index.css"],"names":[],"mappings":"AAAA,sCACI,iBAAA,CAGJ,uBACI,mBAAA,CACA,kBAAA","sourcesContent":[".inlinePaginationOuterWrapper {\n    margin-right: 16px;\n}\n\n.paginationRow {\n    display: inline-flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlinePaginationOuterWrapper": "inlinePaginationOuterWrapper___prU7F",
	"paginationRow": "paginationRow___A9CRT"
};
export default ___CSS_LOADER_EXPORT___;
